module.exports = __webpack_public_path__ + "static/img/scene.8338ccc.glb";


//////////////////
// WEBPACK FOOTER
// ./src/components/terrain/3d/scene.glb
// module id = cTkz
// module chunks = 1